import { useState } from "react"
import { IProductLocationStockResponseItem, useApi } from "../hooks/useApi"
import { useAsyncEffect } from "../hooks/useAsyncEffect"

/**
 * Cheap stock figures (in stock, allocated, explicitly allocated) for many product locations at once, keyed by
 * location id, from the slim lookup (60s cache, allocation map). For list views that colour or flag many rows.
 * The result is `{}` until the first response arrives, and again while a change of locations loads.
 */
export function useLocationsStockValues(productLocationIds: string[]) {
  const api = useApi()
  const [stock, setStock] = useState<Record<string, IProductLocationStockResponseItem>>({})

  useAsyncEffect(
    async ({ isAlive }) => {
      // Drop the previous figures straight away so they are never shown against different locations
      setStock({})
      if (productLocationIds.length === 0) {
        return
      }
      const result = await api.productLocationsStock(productLocationIds, { onlyValues: true })
      if (isAlive()) {
        setStock(result)
      }
    },
    [JSON.stringify(productLocationIds)],
  )

  return stock
}
